import React from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import { experience } from '../data';
import '../styles/theme.css';

export default function Experience() {
  const fade = useFadeIn();

  return (
    <section id="experience" className="section">
      <SectionLabel>Experience</SectionLabel>
      <div ref={fade.ref} style={fade.style}>
        {experience.map((job, idx) => (
          <div key={job.id} className="exp__item">
            <div className="exp__left">
              <div className="exp__date">{job.date}</div>
              <div className="exp__company">{job.company}</div>
              <div className="exp__location">{job.location}</div>
            </div>

            <div>
              <div className="exp__role">{job.role}</div>
              <ul className="exp__list">
                {job.bullets.map((b, i) => (
                  <li key={i} className="exp__bullet">{b}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
